import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ApplicationLoanDetailsData {
  expenseDetails: any[];
  feesDetails: any[];
  vasDetails: any[];
}

const initialState: ApplicationLoanDetailsData = {
  expenseDetails: [],
  feesDetails: [],
  vasDetails: [],
};

const disbursementRequestDataSlice = createSlice({
  name: "disbursementRequestData",
  initialState,
  reducers: {
    setExpenseDetailsDrf: (state, action: PayloadAction<any>) => {
      state.expenseDetails = action.payload;
    },
    setFeesDetails: (state, action: PayloadAction<any>) => {
      state.feesDetails = action.payload;
    },
    setVasDetails: (state, action: PayloadAction<any>) => {
      state.vasDetails = action.payload;
    },
  },
});

export const { setExpenseDetailsDrf, setFeesDetails, setVasDetails } =
  disbursementRequestDataSlice.actions;
export default disbursementRequestDataSlice.reducer;
